import { render, staticRenderFns } from "./PayInOffice.vue?vue&type=template&id=b5df8154&scoped=true&lang=pug&"
import script from "./PayInOffice.vue?vue&type=script&lang=js&"
export * from "./PayInOffice.vue?vue&type=script&lang=js&"
import style0 from "./PayInOffice.vue?vue&type=style&index=0&id=b5df8154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5df8154",
  null
  
)

export default component.exports